module.exports = __webpack_public_path__ + "static/media/at.0721b307.svg";